import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialogViewModel from "./../factories/bao-dialog";
import baoRouter from "./../services/bao-router";
import "./../bindings/bao-toolbar2";
import "./../bindings/bao-upload";
function TicketReferenceDocumentViewModel(tabPage, parent) {
    var self = this;
    self.Bao = Bao;
    self.IsReadonly = parent.IsReadonly;
    self.RefreshInProgress = ko.observable(false);
    self.PageIndex = ko.observable(0);
    self.PageIndex.subscribe(function () {
        self.RefreshGrid();
    });
    self.PageSize = ko.observable(10);
    self.TotalRows = ko.observable(0);
    self.Sorting = ko.observableArray();
    self.Sorting.subscribe(function () {
        self.RefreshGrid();
    });
    self.ReferenceDocumentCollection = ko.observableArray([]);
    self.toolbarClick = function (action) {
        switch (action.ActionKey()) {
            case "AddTicketReferenceDocument":
                self.ShowTicketReferenceDocumentDialog(parent.TicketId(), null);
                break;
            case "EditTicketReferenceDocument":
                if (self.SelectedReferenceDocumentRow() != null) {
                    self.ShowTicketReferenceDocumentDialog(parent.TicketId(), self.SelectedReferenceDocumentRow().OpenData);
                }
                break;
            case "DeleteTicketReferenceDocument":
                if (self.SelectedReferenceDocumentRow() != null) {
                    self.DeleteTicketReferenceDocument(parent.TicketId(), self.SelectedReferenceDocumentRow().OpenData);
                }
                break;
            case "DownloadTicketReferenceDocument":
                if (self.SelectedReferenceDocumentRow() != null) {
                    self.DownloadTicketReferenceDocument(self.SelectedReferenceDocumentRow().OpenData);
                }
                break;
        }
    };
    self.Refresh = function () {
        tabPage.IsLoading(true);
        var def = $.Deferred();
        Bao.post("TicketReferenceDocument/ResetTicketReferenceDocument", JSON.stringify({
            sessionTabId: parent.TabPage.SessionTabId
        }), function () {
            self.RefreshGrid().then(def.resolve);
        });
        return def.promise();
    };
    self.RefreshGrid = function () {
        tabPage.IsLoading(true);
        return Bao.post("TicketReferenceDocument/GetReferenceDocumentCollection", JSON.stringify({
            sessionTabId: parent.TabPage.SessionTabId,
            ticketId: parent.TicketId(),
            pageIndex: self.PageIndex(),
            pageSize: self.PageSize(),
            sorting: self.Sorting()
        }), function (searchResult) {
            tabPage.IsLoading(false);
            self.SelectedReferenceDocumentRow(null);
            self.TotalRows(0);
            self.ReferenceDocumentCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                parent.HasDocuments.dirtyExtender.setWithoutDirty(true);
                self.ReferenceDocumentCollection(searchResult.Models);
                self.TotalRows(searchResult.TotalRows);
            }
            else {
                parent.HasDocuments.dirtyExtender.setWithoutDirty(false);
            }
        });
    };
    var _msgCancel = Bao.Session.GetMessage("msgCancel");
    var _msgOk = Bao.Session.GetMessage("msgOk");
    self.AddTicketReferenceDocument = function (model, ticketId) {
        tabPage.IsLoading(true);
        Bao.post("TicketReferenceDocument/AddReferenceDocument", JSON.stringify({
            sessionTabId: parent.TabPage.SessionTabId,
            referenceDocumentModel: ko.map.toJS(model),
            ticketId: ticketId
        }), function () {
            parent.TabPage.DirtyFlag.setDirty();
            self.RefreshGrid();
        });
    };
    self.DeleteTicketReferenceDocument = function (ticketId, ticketReferenceDocumentId) {
        self.RefreshInProgress(true);
        Bao.post("TicketReferenceDocument/DeleteReferenceDocument", JSON.stringify({
            sessionTabId: parent.TabPage.SessionTabId,
            ticketId: ticketId,
            ticketReferenceDocumentId: ticketReferenceDocumentId
        }), function () {
            self.RefreshInProgress(false);
            parent.TabPage.DirtyFlag.setDirty();
            self.RefreshGrid();
        });
    };
    self.DownloadTicketReferenceDocument = function (ticketReferenceDocumentId) {
        baoRouter.setHash("document/" + ticketReferenceDocumentId);
    };
    self.Save = function (saveTime) {
        var def = $.Deferred();
        Bao.post("TicketReferenceDocument/SaveReferenceDocumentCollection", JSON.stringify(ko.map.toJS({
            sessionTabId: parent.TabPage.SessionTabId,
            ticketId: parent.TicketId,
            saveTime: saveTime
        })), function () {
            self.Refresh().then(def.resolve);
        });
        return def.promise();
    };
    self.Dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
    self.Dialog.Width("450px");
    self.Dialog.Buttons([{
            Title: _msgOk,
            Click: function () {
                if (!Bao.Utils.String.IsNullOrEmpty(self.Dialog.ViewModel().DocumentName())) {
                    self.Dialog.IsLoading(true);
                    $.when(self.Dialog.ViewModel().Upload()).then(function () {
                        self.Dialog.IsLoading(false);
                        self.AddTicketReferenceDocument(self.Dialog.ViewModel(), parent.TicketId());
                        self.Dialog.Close();
                    });
                }
                else {
                    new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
                }
            },
            Enabled: ko.observable(true)
        }, {
            Title: _msgCancel,
            Click: function () {
                self.Dialog.Close();
            },
            Enabled: ko.observable(true)
        }]);
    self.ShowTicketReferenceDocumentDialog = function (ticketId, ticketReferenceDocumentId) {
        Bao.post("TicketReferenceDocument/ShowReferenceDocumentDialog", JSON.stringify({
            sessionTabId: parent.TabPage.SessionTabId,
            ticketId: ticketId,
            ticketReferenceDocumentId: ticketReferenceDocumentId
        }), function (value) {
            var dialogModel = ko.map.fromJS(value.Model);
            dialogModel.Upload = function () { };
            self.Dialog.ViewModel(dialogModel);
            self.Dialog.Template(value.Message);
            self.Dialog.Open();
        });
    };
    self.ToolbarButtons = ko.observableArray([]);
    self.ToolbarButtons.subscribe(function () {
        self.ToggleToolbarButtons();
    });
    self.SelectedReferenceDocumentRow = ko.observable({});
    self.SelectedReferenceDocumentRow.subscribe(function () {
        self.ToggleToolbarButtons();
    });
    self.ToggleToolbarButtons = function () {
        ko.utils.arrayForEach(self.ToolbarButtons(), function (button: any) {
            if (parent.IsReadonly()) {
                switch (button.ActionKey()) {
                    case "AddTicketReferenceDocument":
                    case "EditTicketReferenceDocument":
                    case "DeleteTicketReferenceDocument":
                        button.Enabled(false);
                        break;
                    case "DownloadTicketReferenceDocument":
                        button.Enabled(!(self.SelectedReferenceDocumentRow() == null));
                        break;
                }
            }
            else {
                switch (button.ActionKey()) {
                    case "EditTicketReferenceDocument":
                    case "DeleteTicketReferenceDocument":
                    case "DownloadTicketReferenceDocument":
                        button.Enabled(!(self.SelectedReferenceDocumentRow() == null));
                        break;
                }
            }
        });
    };
}
export default TicketReferenceDocumentViewModel;